import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-white border-t border-[#e5e5e5]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 lg:gap-16">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <span className="font-mono text-xs text-[#0038FF]">[ 01 ]</span>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#0038FF]">
                Who We Are
              </span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              data-testid="about-heading"
              className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl font-black tracking-tighter text-[#0a0a0a] leading-[1.05] break-words hyphens-auto"
            >
              An IT solutions
              <br />
              partner. Built for{" "}
              <span className="italic font-medium text-[#0038FF]">
                long-haul
              </span>{" "}
              outcomes.
            </motion.h2>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:pl-12">
            <div className="space-y-7 text-lg text-[#4a4a4a] leading-relaxed max-w-2xl">
              <p>
                Intelvolks is a software development and consulting firm
                partnering with category-defining enterprises across{" "}
                <span className="text-[#0a0a0a] font-semibold">Edutech</span>{" "}
                and{" "}
                <span className="text-[#0a0a0a] font-semibold">
                  Food-tech
                </span>
                . We design, engineer, and operate the platforms that move
                ambitious organisations from spreadsheets to scale.
              </p>
              <p>
                We pair deep stakeholder expertise with disciplined engineering
                — covering resource planning, process &amp; communication
                management, KPI visibility, and operational forecasting. The
                result: technology that compounds, not technology that costs.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-[#e5e5e5] pt-10">
              {[
                { k: "Edutech", v: "Flagship" },
                { k: "Food-tech", v: "Specialist" },
                { k: "CoE", v: "Always-on" },
                { k: "Partnership", v: "Long-term" },
              ].map((item) => (
                <div key={item.k} data-testid={`about-stat-${item.k.toLowerCase()}`}>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4a4a4a]">
                    {item.k}
                  </div>
                  <div className="font-display text-xl sm:text-2xl font-bold text-[#0a0a0a] mt-2">
                    {item.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
